import { render } from "./NDIComponent.vue?vue&type=template&id=5ddf6d13&scoped=true&ts=true"
import script from "./NDIComponent.vue?vue&type=script&lang=ts"
export * from "./NDIComponent.vue?vue&type=script&lang=ts"

import "./NDIComponent.vue?vue&type=style&index=0&id=5ddf6d13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddf6d13"]])

export default __exports__